import { ofetch, FetchError } from 'ofetch';
import { ApiClientError } from '../api/errors';
import { createDebugLogger } from '../utils/debug';
import { attachBearer } from '../auth/attachBearer';

const dlog = createDebugLogger('orbit-api');

/**
 * Orbit-API-Client.
 *
 * Geht IMMER über den BFF-Proxy `/proxy/orbit-api/...`. Operator-Bearer +
 * Brand-Origin werden vom Backend-Proxy 1:1 durchgereicht — die Hooks setzen
 * sie pro Call (siehe pages/Tickets/useTickets.js).
 *
 * Spec: lmm-wiki/wiki/orbit-specs/orbit-tickets.md
 * Design-Doku: 02_applications/02_orbit.valitype.com/backend/api-design.md
 */

const raw = ofetch.create({
  baseURL: '/proxy/orbit-api',
  onRequest(ctx) {
    attachBearer(ctx); // #501
    dlog('→ /proxy/orbit-api', ctx.request);
  },
  onResponse({ request, response }) {
    dlog('← /proxy/orbit-api', request, response.status);
  },
});

export async function orbitApiFetch(path, opts = {}) {
  try {
    return await raw(path, opts);
  } catch (err) {
    if (err instanceof FetchError) {
      const data = err.data;
      const code = data?.error?.code ?? 'orbit_request_failed';
      const message = data?.error?.message ?? err.message;
      throw new ApiClientError({
        code,
        message,
        status: err.response?.status ?? 0,
        details: data?.error?.details,
      });
    }
    throw err;
  }
}

export function isOrbitApiProxyEnabled() {
  if (typeof window === 'undefined') return false;
  return window.__ORBIT_CONFIG__?.orbitApiProxyEnabled === true;
}
